/* Button Assignment Guard
 * Detects if two designated custom-select dropdowns pick the same value.
 * On duplicate, shows a confirmation dialog. If user cancels, reverts the second selection.
 * Assumptions:
 *  - Add data-role="button-assignment" on the wrapping variant-picker or a parent.
 *  - Each dropdown custom-select should have a data-assignment="primary" / "secondary" (or another label) and options with data-value.
 *  - We run only on quick-picks-2025 template to avoid site-wide overhead.
 */
(function(){
  if (!document.body.classList.contains('template-product') || !document.body.classList.contains('template-product--quick-picks-2025')) return;
  // Find assignment selects (allow flexible naming)
  const selects = Array.from(document.querySelectorAll('custom-select[data-assignment]'));
  if (selects.length < 2) return;

  const state = new Map(); // assignmentName -> lastValue
  selects.forEach(sel => {
    const name = sel.getAttribute('data-assignment');
    const selected = sel.querySelector('[aria-selected="true"]');
    if (selected) state.set(name, selected.dataset.value);
  });

  function valueOf(sel){
    const opt = sel.querySelector('[aria-selected="true"]');
    return opt ? opt.dataset.value : undefined;
  }

  function handleChangeFor(sel){
    const name = sel.getAttribute('data-assignment');
    const val = valueOf(sel);
    if (!val) { state.set(name, val); return; }

    // Compare with every other assignment value
    for (const [otherName, otherVal] of state.entries()) {
      if (otherName !== name && otherVal && otherVal === val) {
        // Duplicate detected
        if (!window.confirm('You selected the same function for both buttons ("' + val + '"). Continue anyway?')) {
          // Revert: find previous different option for this select
          const prev = Array.from(sel.querySelectorAll('.custom-select__option')).find(o => o.dataset.value === state.get(name));
          if (prev) {
            // Programmatically select previous without triggering infinite loop
            prev.setAttribute('aria-selected','true');
            sel.querySelectorAll('.custom-select__option').forEach(o=>{ if(o!==prev) o.setAttribute('aria-selected','false'); });
            const btnSpan = sel.querySelector('.custom-select__btn span');
            if (btnSpan) btnSpan.textContent = prev.firstElementChild ? prev.firstElementChild.textContent : prev.textContent;
            return; // abort updating state so previous remains
          }
        } else {
          break; // user confirmed duplicate; keep selection
        }
      }
    }
    state.set(name, val);
  }

  // Attach listeners to custom-select change (if custom event is dispatched) AND fallback to native select events
  selects.forEach(sel => {
    // Listen for custom change events (only fired when no native select is present)
    sel.addEventListener('change', () => handleChangeFor(sel));
    // If a native select exists (include_native true), its change event bubbles outside the custom-select element.
    const native = document.getElementById(sel.id + '-native');
    if (native) {
      native.addEventListener('change', () => handleChangeFor(sel));
    }
  });
  try { console.debug('[button-assignment-guard] active on', selects.map(s=>s.getAttribute('data-assignment'))); } catch(e) {}
})();
